module.exports = __webpack_public_path__ + "img/banner-2-1@1x.0af2c1b9.jpg";